import React from 'react';
import ModalInner from '../../components/layoutItems/modalInner';
import { Translate, withLocalize } from 'react-localize-redux';
import ResponsiveTable from '../../components/layoutItems/responsiveTable';
import { SemaphoreGroup } from '../../components/common/semaphors';
import { connect } from 'react-redux';
import Section from '../common/section'

class LegendPopup extends React.Component {
    render() {
        return (
            <ModalInner title={this.props.translate('Charts.LegendsToolTip')} close={this.props.close}>
                {this.renderSection('Charts.Legend.WarningsSectionName', this.props.legendData.warnings)}
                {this.renderSection('Charts.Legend.InfoSectionName', this.props.legendData.supplementary)}
                <Section name={this.props.translate('Charts.WarningTableHelpAbbreviationTitle')}>
                    <ResponsiveTable>
                        <table className="table table-report-section">
                            <thead>
                                <tr>
                                    <th><Translate id='Charts.WarningTableHelpGroupName' /></th>
                                    <th><Translate id='Charts.WarningTableHelpAbbreviation' /></th>
                                </tr>
                            </thead>
                            <tbody>{this.renderRelTypeRow(this.props.domains.relationTypes, 0)}</tbody>
                        </table>
                    </ResponsiveTable>
                </Section>
                {this.renderSemaphoreSection('SK')}
                {this.renderSemaphoreSection('CZ')}
            </ModalInner>
        )
    }

    renderSection = (sectionName, values) => (<>
        <Section name={this.props.translate(sectionName)}>
            <ResponsiveTable>
                <table className="table table-report-section">
                    <thead>
                        <tr>
                            <th><Translate id='Charts.WarningTableHelpAbbreviation' /></th>
                            <th><Translate id='Charts.WarningTableHelpDescription' /></th>
                            <th><Translate id='Charts.WarningTableHelpSource' /></th>
                        </tr>
                    </thead>
                    <tbody>{
                        values.map((w, index) => (
                            <tr key={index}>
                                <td data-label={this.props.translate('Charts.WarningTableHelpAbbreviation')}>
                                    <span>{w.Shortening}</span>
                                </td>
                                <td data-label={this.props.translate('Charts.WarningTableHelpDescription')}>
                                    <span>{w.Description}</span>
                                </td>
                                <td data-label={this.props.translate('Charts.WarningTableHelpDescription')}>
                                    <span>{w.Source}</span>
                                </td>
                            </tr>
                        ))
                    }</tbody>
                </table>
            </ResponsiveTable>
        </Section>
    </>)

    renderSemaphoreSection = country => (<>
        <Section name={this.props.translate('Charts.SemaphoreTitle' + country)}>
            <ResponsiveTable>
                <table className="table table-report-section">
                    <thead>
                        <tr>
                            <th><Translate id='Report.Ratings.SemaphoreCribis' /></th>
                            <th><Translate id='Report.Common.Note' /></th>
                        </tr>
                    </thead>
                    <tbody>{
                        ['Na', 'Plus', 'Neutral', 'Minus'].map((semaphore, index) => (
                            <tr key={semaphore}>
                                <td className='always-new-line' data-label={this.props.translate('Report.Ratings.SemaphoreCribis')}>
                                    <SemaphoreGroup value={index} size='medium' className='explanatory' />
                                </td>
                                <td data-label={this.props.translate('Report.Common.Note')}><span>
                                    <Translate
                                        id={`Report.Ratings.Explanatory.SemaphoreCribis${semaphore}${country}`}
                                        options={{ renderInnerHtml: true }} />
                                </span></td>
                            </tr>
                        ))
                    }</tbody>
                </table>
            </ResponsiveTable>
        </Section>
    </>)

    renderRelTypeRow = (relTypes, level) => (
        <React.Fragment>
            {relTypes.map((rt, index) => (
                <React.Fragment key={rt.value}>
                    <tr level={level} onClick={(e) => this.relTypeClick(e)} style={{ cursor: rt.children.length > 0 ? 'pointer' : 'default' }}>
                        <td data-label={this.props.translate('Charts.WarningTableHelpGroupName')}>
                            <span style={{ paddingLeft: level * 10 + 'px' }}>{rt.label}</span>
                        </td>
                        <td data-label={this.props.translate('Charts.WarningTableHelpAbbreviation')}>
                            <span>{rt.shortening}</span>
                        </td>
                    </tr>
                    {this.renderRelTypeRow(rt.children, level + 1)}
                </React.Fragment>
            ))}
        </React.Fragment>
    )

    relTypeClick = (e) => {
        var collapsing = e.currentTarget.className.indexOf('collapsed') == -1;
        if (collapsing)
            e.currentTarget.classList.add('collapsed');
        else
            e.currentTarget.classList.remove('collapsed');
        var level = e.currentTarget.getAttribute('level');
        var next = e.currentTarget.nextElementSibling;

        while (next != null) {

            if (next.getAttribute('level') <= level) {
                return;
            }

            if (next.style.display == 'none' && collapsing || next.style.display != 'none' && !collapsing) {
            }
            else if (next.style.display == 'none')
                next.style.display = '';
            else
                next.style.display = 'none';

            next = next.nextElementSibling;
        }
    }
}

export default withLocalize(connect(state => state.charts)(LegendPopup));